import { cva, type VariantProps } from "class-variance-authority";
import { type ComponentPropsWithRef, useId } from "react";
import type { WithRequired } from "@/types";
import { cn } from "@/utils/style.ts";

const labelVariants = cva("custom-control__label", {
    variants: {
        variant: {
            withIcon: "with-icon",
            default: "",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

type LabelVariants = VariantProps<typeof labelVariants>;
type Props = WithRequired<Omit<ComponentPropsWithRef<"input">, "type">, "name"> & LabelVariants;
export default function RadioInput({ children, className, variant, ...props }: Props) {
    const id = useId();

    return (
        <div className={cn("custom-control custom-control--radio", className)}>
            <input {...props} id={id} type="radio" className="custom-control__input" />
            <label className={labelVariants({ variant })} htmlFor={id}>
                {children}
            </label>
        </div>
    );
}
